var map = {
	"./baccarat2_en.png": "gXDd",
	"./baccarat2_esp.png": "SDa+",
	"./baccarat2_th.png": "Z0gN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "jjhL";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas ^\.\/baccarat2_.*\.png$
// module id = jjhL
// module chunks = 1